import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class AppLoadingServiceProvider {
  public appLoaded: BehaviorSubject<boolean>;
  public menuLoaded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() {
    this.appLoaded = new BehaviorSubject(false);
  }

  public setStatus(status: boolean) {
    this.appLoaded.next(status);
  }

  public setMenuLoaded(status: boolean) {
    this.menuLoaded.next(status);
  }
}



// WEBPACK FOOTER //
// ./src/modules/core/services/app-loading-service/AppLoadingServiceProvider.ts